import http from '../common/http';
import env from '../envConfig';
import { getHeader } from '../auth/authManager';
import { responseHandler } from '../common/responseHandler';
import auth from '../auth/Auth';


export interface UploadUrlResponse {
  url: string;
  objectKey: string;
}

export interface DownloadUrlResponse {
  url: string;
  objectKey: string;
}

export interface SalvarCarteiraDocumentoDTO {
  nuCpfPessoa: number;
  tipoDocumento: number;
  teChaveDocumento: string;
  nmArquivoDocumento: string;
  teFormatoArquivoDocumento: string;
  tamanhoArquivoKb: number;
  nomeUsuarioUpload: string;
  nomePessoa: string;
}

export interface SalvarDocumentoResponse {
  documentoValido: boolean;
  documentoSalvo: any | null;
}


export const obterUploadUrl = async (nomeArquivo: string, tipoDocumento: string): Promise<UploadUrlResponse> => {
  const url = env.urlApi + `/transacional-api/v1/carteira-documentos/upload-url?nomeArquivo=${encodeURIComponent(nomeArquivo)}&tipoDocumento=${tipoDocumento}`;
  const headers = getHeader();
  const response = await http.get(url, { headers }).catch((e) => e);
  const resultado = responseHandler(response) as UploadUrlResponse;
  if (!resultado?.url || !resultado?.objectKey) {
    throw new Error('Não foi possível enviar documento. Tente novamente mais tarde.');
  }
  return resultado;
};

export const uploadArquivoStorage = async (uploadUrl: string, blob: Blob, nomeArquivo: string): Promise<void> => {
  await fetch(uploadUrl, {
    method: 'PUT',
    body: blob,
    headers: {
      'x-amz-meta-nome_arquivo': nomeArquivo,
      'Content-Type': '',
    },
  });
};

export const obterDownloadUrl = async (objectKey: string): Promise<DownloadUrlResponse> => {
  const url = env.urlApi + `/transacional-api/v1/carteira-documentos/download-url?objectKey=${encodeURIComponent(objectKey)}`;
  const headers = getHeader({ 'x-jwt-assertion': auth.getToken() });
  const response = await http.get(url, { headers }).catch((e) => e);
  return responseHandler(response) as DownloadUrlResponse;
};

export const salvarDocumento = async (
  objectKey: string,
  tipoDocumento: string,
  cpfPessoa: string,
  nomeArquivo: string,
  tamanhoBytes: number,
  mimeType: string,
  nomeUsuarioUpload: string,
  nomePessoa: string,
): Promise<any> => {
  const url = env.urlApi + `/transacional-api/v1/carteira-documentos/salvar-documento`;
  const headers = getHeader({ 'x-jwt-assertion': auth.getToken() });
  const ext = nomeArquivo.includes('.') ? nomeArquivo.split('.').pop()! : mimeType.split('/').pop() || 'jpg';
  const body: SalvarCarteiraDocumentoDTO = {
    nuCpfPessoa: Number(cpfPessoa),
    tipoDocumento: Number(tipoDocumento),
    teChaveDocumento: objectKey,
    nmArquivoDocumento: nomeArquivo,
    teFormatoArquivoDocumento: ext,
    tamanhoArquivoKb: Math.round((tamanhoBytes || 0) / 1024),
    nomeUsuarioUpload,
    nomePessoa,
  };
  const response = await http.put(url, body, { headers }).catch((e) => e);
  const resultado = responseHandler(response) as SalvarDocumentoResponse;
  if (!resultado.documentoValido) {
    throw new Error('Documento inválido. Verifique o arquivo e tente novamente.');
  }
  return resultado.documentoSalvo;
};

export const excluirDocumento = async (id: number): Promise<void> => {
  const url = env.urlApi + `/transacional-api/v1/carteira-documentos/${id}`;
  const headers = getHeader({ 'x-jwt-assertion': auth.getToken() });
  const response = await http.delete(url, { headers, validateStatus: (s) => s === 204 || s === 401 || s === 403 || s === 500 }).catch((e) => e);
  const status = response?.status ?? response?.response?.status;
  if (status === 204) return;
  if (status === 401) throw new Error('Sessão expirada. Faça login novamente.');
  if (status === 403) throw new Error('Você não tem permissão para excluir este documento.');
  throw new Error('Erro ao excluir o documento. Tente novamente.');
};
